import dayjs from 'dayjs';

const makeDayTestLocator = (day: Date): string =>
  dayjs(day).format('DD-MM-YYYY');

export { makeDayTestLocator };
